import React, { useState } from 'react';

const CreateClientModal = ({ onClose, onCreateClient }) => {
    const [clientName, setClientName] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [clientEmail, setClientEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!clientName || !contactPerson || !clientEmail) {
            setError('Please fill all required fields.');
            return;
        }
        setLoading(true);
        try {
            await onCreateClient({
                name: clientName,
                contactPerson: contactPerson,
                email: clientEmail
            });
            onClose();
        } catch (err) {
            setError('Failed to add client.');
        }
        setLoading(false);
    };

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.4)', backdropFilter: 'blur(8px)', padding: '1rem',
        }} onClick={onClose}>
            <div style={{
                position: 'relative', padding: '2rem', background: 'var(--color-bg)', width: '100%', maxWidth: 480, margin: 'auto', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', maxHeight: '90vh', overflowY: 'auto',
            }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--color-primary)' }}>Add New Client</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--color-text-light)', fontSize: '1.5rem', cursor: 'pointer' }}>&times;</button>
                </div>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                        <label htmlFor="clientNameAddModal" style={{ display: 'block', fontSize: '1rem', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>Client Name</label>
                        <input id="clientNameAddModal" type="text" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={clientName} onChange={e => setClientName(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="contactPersonAddModal" style={{ display: 'block', fontSize: '1rem', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>Contact Person</label>
                        <input id="contactPersonAddModal" type="text" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={contactPerson} onChange={e => setContactPerson(e.target.value)} required />
                    </div>
                    <div>
                        <label htmlFor="clientEmailAddModal" style={{ display: 'block', fontSize: '1rem', fontWeight: 500, color: 'var(--color-text)', marginBottom: 4 }}>Email</label>
                        <input id="clientEmailAddModal" type="email" style={{ width: '100%', padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius)', color: 'var(--color-text)', background: 'var(--color-bg)', fontSize: '1rem' }} value={clientEmail} onChange={e => setClientEmail(e.target.value)} required />
                    </div>
                    {error && <div style={{ background: 'var(--color-error)', color: 'var(--color-text-inverse)', borderRadius: 'var(--border-radius)', padding: '0.5rem', fontSize: '0.95rem' }}>{error}</div>}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.5rem' }}>
                        <button type="button" onClick={onClose} style={{ background: 'var(--color-secondary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer' }}>Cancel</button>
                        <button type="submit" disabled={loading} style={{ background: 'var(--color-primary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.5rem 1.25rem', fontSize: '1rem', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>{loading ? 'Saving...' : 'Save Client'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateClientModal; 